module.exports = __webpack_public_path__ + "static/media/pennepestotomato.e12d3eee.jpg";